module.exports = __webpack_public_path__ + "media/ets/telecom-mobile-ets-min-2209c08b.png";